import { Text } from '@capsicum/common-web';
import { PasswordClosedIcon, PasswordIcon } from '@capsicum/common-web/icons';
import { type NCWalletBalanceProps, ncwPrivacyModeAtom, useNCWalletBalance } from '@capsicum/features/nc-wallet/shared';
import { useNCWBalance } from '@capsicum/socios-core';
import { useAtom } from 'jotai';
import { type SVGProps } from 'react';
import styled, { useTheme } from 'styled-components';

import { TotalBalance } from './TotalBalance';

/**
 * This component returns the Non Custodial Wallet Balance UI compoment
 */
export const NCWalletBalance = ({ isLoading = false }: NCWalletBalanceProps) => {
	const { colors } = useTheme();
	//get shared logic from the Mob/Web UI componet shared hook
	const { intlText, onTogglePrivacyMode } = useNCWalletBalance();
	//get NCW balance from the Web specific hook
	const { formattedAltBalance, isPending } = useNCWBalance();
	const [privacyMode] = useAtom(ncwPrivacyModeAtom);

	const iconProps = {
		height: 20,
		style: {
			color: colors.icons.main.enabled
		},
		width: 20
	} satisfies SVGProps<SVGSVGElement>;

	return (
		<S.Wrapper>
			<S.TitleAndPrivacy>
				<S.Title color="main.enabled" variant="text4">
					{intlText.totalBalance}
				</S.Title>
				<div data-testid="ncwHome-walletBalancePrivacyMode-toggle" onClick={onTogglePrivacyMode}>
					{privacyMode ? <PasswordClosedIcon {...iconProps} /> : <PasswordIcon {...iconProps} />}
				</div>
			</S.TitleAndPrivacy>
			<TotalBalance
				balance={formattedAltBalance}
				isLoading={isPending || isLoading}
				testID="ncwHome-walletBalance-totalBalance"
			/>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		padding: ${({ theme }) =>
			`${theme.spacings.large} ${theme.spacings.large} ${theme.spacings.xxxsmall} ${theme.spacings.large}`};
		color: ${({ theme }) => theme.colors.backgrounds.main.container};
		text-align: center;
	`;

	export const TitleAndPrivacy = styled.div`
		display: inline flex;
		flex-direction: row;
		align-items: center;
		padding-bottom: ${({ theme }) => theme.spacings.xxxsmall};
	`;

	export const Title = styled(Text)`
		margin-inline-end: ${({ theme }) => theme.spacings.xxxsmall};
	`;
}
